import * as actions from '../constants/actions';

export const initialState = {
	testing: false,
	progress: 0,
	duration: 0,
	mbps: 0,
	downloaded: 0,
	error: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case actions.NETWORKHEALTH_SPEED_TEST_START:
			return {
				...initialState, // reset state
				testing: true
			};
		case actions.NETWORKHEALTH_SPEED_TEST_COMPLETE:
			return {
				...state,
				testing: false,
				...action.payload
			};
		case actions.NETWORKHEALTH_UPDATE_SPEED_TEST:
			return {
				...state,
				...action.payload
			};
		case actions.NETWORKHEALTH_SPEED_TEST_ERROR:
			const error = action.payload;
			return {
				...state,
				testing: false,
				progress: 1,
				error: error.message || error
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/speedTest.js